import React, { useEffect, useState } from "react";
import { FormGroup, Button, Container, Input, Label, Row } from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { WriteReview } from "../../apis/Reviews";
import { Star } from "lucide-react";
import { AxiosError } from "axios";
import { z } from "zod";
// Define the Zod schema for validation
const ReviewsSchema = z.object({
  propertyId: z.string().regex(/^[a-fA-F0-9]{24}$/, "Invalid id format"),
  content: z
    .string()
    .min(3, { message: "Content must be at least 3 characters long." }),
  rating: z.number().int().min(1, "Rating required").max(5, "Rating required"),
});
const WriteReviews = () => {
  const [propertyId, setPropertyId] = useState("");
  const [content, setContent] = useState("");
  const [rating, setRating] = useState(0);
  const [errors, setErrors] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const validationResult = ReviewsSchema.safeParse({
        propertyId,
        content,
        rating,
      });
      if (!validationResult.success) {
        const fieldErrors = {};
        validationResult.error.errors.forEach((error) => {
          if (error.path.includes("propertyId")) {
            fieldErrors.propertyId = error.message;
          } else if (error.path.includes("content")) {
            fieldErrors.content = error.message;
          } else if (error.path.includes("rating")) {
            fieldErrors.rating = error.message;
          }
        });
        setErrors(fieldErrors);
        return;
      }
      const response = await WriteReview(
        propertyId,
        content,
        rating.toString()
      );
      if (response) {
        toast.success("Review created Successfully");
        //   Reset form after submission
        setPropertyId("");
        setContent("");
        setRating(0);
        setErrors([]);
      } else {
        toast.error("Review Creation Failed");
      }
    } catch (err) {
      if (err instanceof AxiosError) {
        toast.error(err.response.data.message);
      } else toast.error("Something went wrong");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
      <Container
        //  h-[calc(100vh-130px)]
        className="px-0 dark:bg-darkBg1 dark:text-[#c7d8eb]"
        fluid
      >
        <div className="p-6 flex flex-col gap-6 ">
          <h1 className="text-2xl dark:text-[#c7d8eb]">Write a review</h1>
          <div className="max-w-2xl p-6 mx-auto w-full border rounded-md">
            <div>
              <AvForm onValidSubmit={handleSubmit}>
                <div className="mb-3 flex flex-col gap-4">
                  <Row className="w-full">
                    <Label
                      className="font-semibold p-0 mx-2 text-base"
                      htmlFor="propertyId"
                    >
                      List ID
                    </Label>
                    <Input
                      className="mx-2 w-full py-3 border rounded-md border-gray-100 dark:!bg-darkBg1 dark:!text-white"
                      type="text"
                      name="serviceFeeType"
                      id="propertyId"
                      value={propertyId}
                      onChange={(e) => setPropertyId(e.target.value)}
                    />
                    {errors.propertyId && (
                      <p className="mt-1 text-red-600">{errors.propertyId}</p>
                    )}
                  </Row>
                  <Row className="w-full">
                    <Label
                      className="font-semibold p-0 mx-2 text-base"
                      htmlFor="content"
                    >
                      Review content
                    </Label>
                    <Input
                      className="mx-2 w-full py-3 h-32 max-h-48 border rounded-md border-gray-100 dark:!bg-darkBg1 dark:!text-white"
                      type="textarea"
                      name="serviceFeeType"
                      id="content"
                      value={content}
                      onChange={(e) => setContent(e.target.value)}
                    />
                    {errors.content && (
                      <p className="mt-1 text-red-600">{errors.content}</p>
                    )}
                  </Row>
                  <Row className="w-full">
                    <div className="font-semibold p-0 mx-2 text-base mb-1">
                      Overall Rating
                    </div>
                    <div className="flex gap-0.5 px-0 mx-2">
                      {Array.from(Array(5), (e, i) => {
                        return (
                          <Star
                            key={i}
                            onClick={() => setRating(i + 1)}
                            className={`${
                              rating >= i + 1
                                ? "fill-primaryColor text-primaryColor"
                                : "fill-gray-400 text-gray-400"
                            } cursor-pointer`}
                            size={30}
                          />
                        );
                      })}
                    </div>

                    {errors.rating && (
                      <p className="mt-1 text-red-600">{errors.rating}</p>
                    )}
                  </Row>
                </div>

                <FormGroup className="mb-0 w-full flex justify-end">
                  <Button type="submit" color="primary" className="me-1">
                    Submit
                  </Button>{" "}
                </FormGroup>
              </AvForm>
            </div>
          </div>
        </div>
      </Container>
      </div>
    </React.Fragment>
  );
};

export default WriteReviews;
